import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/ys_footer_logo.svg")